import { combineReducers } from 'redux';
import get from 'lodash/get';
import actionTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
  DESKTOP_REVIEW_ACTION_PREFIX,
} from './actionTypes';

const initialState = {
  desktopReviewId: '',
  data: [],
  pagination: {
    current: 1,
    pageSize: 10,
  },
  total: 0,
  sorter: {
    key: '',
    value: '', // desc ||asc
  },
  loading: false,
  error: null,
};

const INITIAL_STATE_GET_ONE = {
  desktopReviewId: '',
  id: '',
  data: null,
  loading: false,
  error: null,
};

const INITIAL_STATE_CHECKOUT = {
  data: null,
  loading: false,
  error: null,
};

const INITIAL_STATE_BANK_TRANSFER = {
  data: null,
  loading: false,
  error: null,
};

const desktopReviewInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    // #region INVOICE_LIST
    case asyncActionTypeRequest(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_LIST`]): {
      const { params = {} } = action.payload;
      return {
        ...state,
        desktopReviewId: get(params, 'desktopReviewId'),
        pagination: {
          current: get(params, 'pageNo'),
          pageSize: get(params, 'pageSize'),
        },
        loading: true,
        error: null,
      };
    }
    case asyncActionTypeSuccess(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_LIST`]): {
      const { response } = action;
      return {
        ...state,
        total: get(response, 'data.pagination.total', 0),
        data: get(response, 'data.list', []),
        loading: false,
        error: null,
      };
    }
    // #endregion
    default: {
      return { ...state };
    }
  }
};

const desktopReviewInvoiceGetOneReducer = (state = INITIAL_STATE_GET_ONE, action) => {
  switch (action.type) {
    // #region INVOICE_LIST
    case asyncActionTypeRequest(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_GET_ONE`]): {
      const { params = {}, id } = action.payload;
      return {
        ...state,
        loading: true,
        error: null,
        id,
        desktopReviewId: get(params, 'desktopReviewId'),
      };
    }
    case asyncActionTypeSuccess(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_GET_ONE`]): {
      const { response } = action;

      return {
        ...state,
        data: get(response, 'data', null),
        loading: false,
        error: null,
      };
    }
    // #endregion
    default: {
      return { ...state };
    }
  }
};

const desktopReviewInvoiceCheckoutReducer = (state = INITIAL_STATE_CHECKOUT, action) => {
  switch (action.type) {
    // #region INVOICE_LIST
    case asyncActionTypeRequest(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT`]): {
      return {
        loading: true,
        error: null,
      };
    }
    case asyncActionTypeSuccess(actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT`]): {
      const { response } = action;
      return {
        ...state,
        data: get(response, 'data', null),
        loading: false,
        error: null,
      };
    }
    // #endregion
    default: {
      return { ...state };
    }
  }
};

const desktopReviewInvoiceBankTransferReducer = (state = INITIAL_STATE_BANK_TRANSFER, action) => {
  switch (action.type) {
    // #region INVOICE_LIST
    case asyncActionTypeRequest(
      actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT_BANK_TRANSFER`]
    ): {
      return {
        loading: true,
        error: null,
      };
    }
    case asyncActionTypeSuccess(
      actionTypes[`${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT_BANK_TRANSFER`]
    ): {
      const { response } = action;
      return {
        ...state,
        data: get(response, 'data', null),
        loading: false,
        error: null,
      };
    }
    // #endregion
    default: {
      return { ...state };
    }
  }
};

export default combineReducers({
  list: desktopReviewInvoiceReducer,
  getOne: desktopReviewInvoiceGetOneReducer,
  checkout: desktopReviewInvoiceCheckoutReducer,
  bankTransfer: desktopReviewInvoiceBankTransferReducer,
});
